import { defineVideoTemplate } from "@assets/templates/builders";
import { BASE_ASSETS } from "@assets/templates/constants";

export const sportsReplayVideoExample = defineVideoTemplate({
  slug: "sports-replay-video-example",
  title: "Motorsport",
  description: "Onboard analysis",
  subdescription: "Break down the racing line through each corner",
  poster: BASE_ASSETS.sportsReplayVideoPoster,
  video: BASE_ASSETS.sportsReplayVideo,
  prompt: "For each corner in this onboard lap, describe the racing line and braking points the driver takes.",
  enableThinking: true,
});
